import React, { useState } from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Button from '@material-ui/core/Button'
import AccountRouterLink from 'components/account-router-link'
import YesNoButtons from '../form-components/yes-no-buttons'
import { useWizardFormContext } from 'components/wizard-form/context'

const PaymentAccount = () => {
  const [isYes, setIsYes] = useState(true)
  const { errors, control } = useFormContext()
  const {
    extraData: { paymentAccounts },
  } = useWizardFormContext()

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box mb={4}>
        <Typography variant="h4" align="center">
          Do you want to accept online payments for this offering?
        </Typography>
      </Box>
      <Box mb={9}>
        <YesNoButtons {...{ isYes, setIsYes }} />
      </Box>
      {isYes ? (
        <>
          <Container maxWidth="sm">
            <Box mb={1}>
              <Typography variant="h5" align="center">
                Select a payment account
              </Typography>
            </Box>
            <Box mb={6}>
              <Typography variant="body1" color="textSecondary" align="center">
                Select a payment account to collect registration fees online for
                this offering. If no payment account is selected, upfront
                payments will not be required.
              </Typography>
            </Box>
            <FormControl error={!!errors.paymentAccountId} variant="outlined">
              <InputLabel id="category">Select payment account</InputLabel>
              <Controller
                defaultValue=""
                as={
                  <Select
                    labelId="paymentAccount"
                    label="Select paymentAccount"
                    value=""
                    defaultValue=""
                  >
                    {paymentAccounts.map(opt => (
                      <MenuItem key={opt.id} value={opt.id}>
                        {opt.name} – x{opt.last4}
                      </MenuItem>
                    ))}
                    <MenuItem key="none" value="">
                      <em>None</em>
                    </MenuItem>
                  </Select>
                }
                name="paymentAccountId"
                control={control}
              />
            </FormControl>
            <Button
              color="primary"
              size="small"
              to="/account/payments/payment-accounts"
              component={AccountRouterLink}
            >
              Manage Payment Accounts
            </Button>
          </Container>
        </>
      ) : null}
    </Box>
  )
}

export default PaymentAccount
